var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.308 22.5c-.505 0-.933-.175-1.283-.525a1.745 1.745 0 01-.525-1.283V3.308c0-.505.175-.933.525-1.283.35-.35.778-.525 1.283-.525h9.384c.505 0 .933.175 1.283.525.35.35.525.778.525 1.283v17.384c0 .505-.175.933-.525 1.283-.35.35-.778.525-1.283.525H7.308zM7 18.25h10V5.75H7v12.5z",
    fill: "currentColor"
  })));
}
SvgPhoneFilled.displayName = 'PhoneFilled';
export default SvgPhoneFilled;